import BaseService from "./geral/BaseService";

const base = "ConsultaDepotTriagemController";

export default class ConsultaDepotTriagemController extends BaseService {
    constructor() {
        super(base);
    }

    ListarItensOrdem (){
        return super.httpGet(`/${base}/ListarItensOrdem`);
    }

    listarFiltro (placa){
        return super.httpGet(`/${base}/Listar?placa=${placa}`);
    }
}


// WEBPACK FOOTER //
// ./src/services/ConsultaDepotTriagemController.js